var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',[_c('b-slider',{attrs:{"size":"is-large","tooltip":false,"rounded":"","min":_vm.block.minimum,"max":_vm.block.maximum,"step":_vm.block.step},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }